module.exports = __webpack_public_path__ + "static/img/10bg_9.11e407e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_9.png
// module id = 625
// module chunks = 1